import React from 'react';
import {connect} from 'react-redux';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import MyButton from '../components/MyButton';
import {logout} from '../login/LoginAction';

class DisableScreen extends React.PureComponent {
	render() {
		const {t} = this.props;
		return (
			<div>
				<div className='toolbar'>
					<div
						className='back-arrow'
						onClick={() => this.props.goBack()}
					>
						<ArrowBack />
					</div>
					<h2 style={styles.flex}>
						{this.props.t('common:accountDisabledTitle')}
					</h2>
					<MyButton
						onPressButton={() => this.props.logout()}
						title={this.props.t('common:logout')}
						color='secondary'
						variant='raised'
					/>
				</div>
				<div style={styles.containerShadowBox}>
					<p>{t('common:accountDisableDescription')}</p>
					<a href='https://toplife.zone/training-anpassen/'>
						{t('common:activateAccount')}
					</a>
				</div>
			</div>
		);
	}
}

const styles = {
	containerShadowBox: {
		maxWidth: 1200,
		margin: '0 auto',
		backgroundColor: colors.white,
		paddingTop: 56,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
};

/*const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
        loadingLevelFailed: state.loadingLevelFailed,
        isLoading: state.levelLoading
    };
};*/

const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => dispatch(logout()),
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	null,
	mapDispatchToProps
)(translate(['common'])(DisableScreen));



// WEBPACK FOOTER //
// ./src/disabled/DisabledScreen.js